// src/components/Celebrations/CelebrationProjectsTab.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { fetchProjectsForEventThunk, submitProjectsThunk } from '../../redux/fetchProjectsThunk';
import userStore from '../../../../zustand/userStore';

const CelebrationProjectsTab = ({ item }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const user_id = userData?.id;

  const category_id = 0; // ✅ celebration
  const categoryKey = "celebration";

  const { eventDetails } = useSelector((state) => state.projects);
  const { projects = [], loading, error } = eventDetails[categoryKey] || {};

  const [selectedProjectIds, setSelectedProjectIds] = useState([]);

  useEffect(() => {
    if (item?.celebration_id) {
      dispatch(fetchProjectsForEventThunk({ category_id, event_id: item.celebration_id }));
    }
  }, [item?.celebration_id, dispatch]);

  const handleCheckboxChange = (id) => {
    setSelectedProjectIds(prev =>
      prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => {
    if (!item?.id) {
      alert("Event ID is missing.");
      return;
    }

    const school_id = 1;
    if (!user_id) {
      alert("User ID is missing.");
      return;
    }

    const projectPayloads = selectedProjectIds.map((projectId) => ({
      school_id,
      user_id,
      project_id: projectId,
      event_id: item.id,
      is_awareness: "0",
      is_celebration: "1",
    }));

    dispatch(submitProjectsThunk({ projectPayloads }))
      .unwrap()
      .then(() => {
        alert("Projects submitted successfully!");
        setSelectedProjectIds([]);
      })
      .catch((error) => {
        console.error("Submission error:", error);
        alert("Failed to submit projects.");
      });
  };

  const applyMultiColumn = projects.length > 10;
  return (
    <div className="card card-body">
      <h3 className="my-0 text-18">Projects for {item?.name || item?.details}</h3>

      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">Error: {error}</p>}

      {!loading && projects.length === 0 && (
        <p>No projects found for this celebration event.</p>
      )}

      <div className="accordion  " id="celebrationProjectAccordion" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px' }}>
        {projects.map((project, index) => (
          <div className="accordion-item  " key={project.id} >
            <h2 className="accordion-header" id={`heading${project.id}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${project.id}`}
                aria-expanded="false"
                aria-controls={`collapse${project.id}`}
              >
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={selectedProjectIds.includes(project.id)}
                  onChange={() => handleCheckboxChange(project.id)}
                />
                <span className="fw-bold me-2">{index + 1}.</span> {project.project_name || project.name}
              </button>
            </h2>
            <div
              id={`collapse${project.id}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${project.id}`}
              data-bs-parent="#celebrationProjectAccordion"
            >
              <div className="accordion-body">
                <p><strong>Description:</strong> {project.project_description || project.description}</p>

                {project.children && project.children.length > 0 && (
                  <>
                    <hr />
                    <p><strong>Sub Projects:</strong></p>
                    <ul className="list-group">
                      {project.children.map(child => (
                        <li className="list-group-item d-flex align-items-center" key={child.id}>
                          <input
                            type="checkbox"
                            className="form-check-input me-2"
                            checked={selectedProjectIds.includes(child.id)}
                            onChange={() => handleCheckboxChange(child.id)}
                          />
                          <div>
                            <strong>{child.project_name || child.name}</strong>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedProjectIds.length > 0 && (
        <div className="text-end mt-3">
          <button className="btn btn-success" onClick={handleSubmit}>Submit Selected Projects</button>
        </div>
      )}
    </div>
  );
};

export default CelebrationProjectsTab;
